let query = {
  read(key) {
    let obj = {};
    let currentQuery = window.location.search;

    let queries = currentQuery && currentQuery.split("?")[1].split("&") || [];

    queries.forEach(query => {
      let split = query.split("=");
      obj[split[0]] = decodeURIComponent(split[1]);
    });

    return key ? obj[key] : obj;
  },

  update(queryObj) {
    let url = window.location.protocol + "//" + window.location.host + window.location.pathname;
    let queryString = "";
    let obj = query.read();

    Object.keys(queryObj).forEach((key, i) => {
      obj[key] = queryObj[key];
    });

    Object.keys(obj).forEach((key, i) => {
      let prefix = "&";
      if(i === 0) {
        prefix = "?"
      }
      if(obj[key]) {
        queryString += prefix + key + "=" + obj[key];
      }
    });

    let newurl = url + queryString;

    window.history.pushState({ path: newurl }, '', newurl);
  },

  remove(keys) {
    let url = window.location.protocol + "//" + window.location.host + window.location.pathname;
    let queryString = "";

    if(keys && keys.length) {
      let obj = query.read();
      keys.forEach((key) => delete obj[key]);

      Object.keys(obj).forEach((key, i) => {
        let prefix = "&";
        if(i === 0) {
          prefix = "?"
        }
        queryString += prefix + key + "=" + obj[key];
      });
    }

    let newurl = url + queryString;

    window.history.pushState({ path: newurl }, '', newurl);
  }
};

export default query;



// WEBPACK FOOTER //
// ./static/js/components/QueryHelper.js